"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisitedOffersFrame = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./VisitedOffersFrame.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VISITED_OFFERS_FRAME_SRC = 'https://static.cdn-cian.ru/frontend/audience-assets/static/visitedOffers/visitedOffers.html';
const VisitedOffersFrame = exports.VisitedOffersFrame = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    onLoad
  } = _ref;
  return /*#__PURE__*/React.createElement("iframe", {
    src: VISITED_OFFERS_FRAME_SRC,
    height: 1,
    className: styles['frame'],
    ref: ref,
    onLoad: onLoad
  });
});
VisitedOffersFrame.displayName = 'VisitedOffersFrame';